import { Store } from "bernie-plugin-mobx";
import { SerializedData } from "bernie-core";
import { NOOP_LOGGER } from "bernie-logger";
import { ExperienceContext, FlexViewModelResponse, UriContext } from "src/typings/flexFramework/FlexDefinitions";

export class UriContextStore extends Store {
  private uriContext?: UriContext;

  public constructor(state: SerializedData = {}) {
    super(state, NOOP_LOGGER);
  }

  public setup(res?: FlexViewModelResponse, experienceContext?: ExperienceContext): void {
    this.uriContext = experienceContext?.uriContext ?? res?.uriContext ?? this.uriContext;
  }

  public get(): UriContext {
    return (
      this.uriContext || {
        identifiers: {},
      }
    );
  }

  public hydrate(data: SerializedData = {}) {
    Object.assign(this, data);
  }

  public toJSON(): SerializedData {
    return {
      uriContext: this.uriContext,
    };
  }
}

export default UriContextStore;
